import { TweenLite } from 'gsap/TweenMax';

const $value = new WeakMap();
const $lerpedValue = new WeakMap();
const $isComplete = new WeakMap();

const defaults = {
  damping: 0.07,
  initialValue: 0,
  onComplete: () => {},
  onTick: () => {},
  precision: 0.001,
};

export default class {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    this.damping = options.damping;
    this.initialValue = options.initialValue;
    this.onTick = options.onTick;
    this.onComplete = options.onComplete;
    this.precision = options.precision;

    this.update = this.update.bind(this);

    this.setValueImmediately(this.initialValue);

    this.init();
  }

  update() {
    if ($isComplete.get(this)) return;

    const value = $value.get(this);
    let lerpedValue = $lerpedValue.get(this);

    const delta = value - lerpedValue;
    if (Math.abs(delta) < this.precision) {
      $lerpedValue.set(this, value);
      this.onTick(value);
      this.onComplete(value);
      $isComplete.set(this, true);
    } else {
      lerpedValue += (value - lerpedValue) * this.damping;
      this.onTick(lerpedValue);
      $lerpedValue.set(this, lerpedValue);
    }
  }

  setValue(_value) {
    $isComplete.set(this, false);
    $value.set(this, _value);
    return this;
  }

  setValueImmediately(_value) {
    this.setValue(_value);
    $lerpedValue.set(this, _value);
    return this;
  }

  getValue() {
    return $value.get(this);
  }

  destroy() {
    TweenLite.ticker.removeEventListener('tick', this.update);
    $value.delete(this);
    $isComplete.delete(this);
    $lerpedValue.delete(this);
  }

  init() {
    TweenLite.ticker.addEventListener('tick', this.update);
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/Lerper.js